"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useConfig3 = _interopRequireDefault(require("./useConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var GOOGLE_ID = 'google-analytics-js';
var GOOGLE_TRACKING_ID = 'google-analytics-config';

var useAnalytics = function useAnalytics() {
  var _useConfig = (0, _useConfig3["default"])(),
      _useConfig2 = _slicedToArray(_useConfig, 1),
      _useConfig2$0$analyti = _useConfig2[0].analytics;

  _useConfig2$0$analyti = _useConfig2$0$analyti === void 0 ? {} : _useConfig2$0$analyti;
  var googleId = _useConfig2$0$analyti.googleId;
  var initialise = (0, _react.useCallback)(function () {
    if (googleId) {
      var existingScript = document.getElementById(GOOGLE_ID);

      if (!existingScript) {
        var googleCode = document.createElement('script');
        googleCode.src = "https://www.googletagmanager.com/gtag/js?id=".concat(googleId);
        googleCode.id = GOOGLE_ID;
        googleCode.defer = true;
        document.body.appendChild(googleCode);
        var googleTracking = document.createElement('script');
        googleTracking.text = 'window.dataLayer = window.dataLayer || []; ' + 'function gtag(){dataLayer.push(arguments);} ' + "gtag('js', new Date()); " + "gtag('config', '".concat(googleId, "'); ");
        googleTracking.id = GOOGLE_TRACKING_ID;
        document.body.appendChild(googleTracking);
      }
    }
  }, [googleId]);
  return {
    initialise: initialise
  };
};

var _default = useAnalytics;
exports["default"] = _default;